module.exports = __webpack_public_path__ + "static/media/b1.18e40c2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengxiaoyue/b1.mp3
// module id = SMWu
// module chunks = 0